// extracted by mini-css-extract-plugin
module.exports = {"container":"switch_container__3V6oe","switch":"switch_switch__H1Nse","slider":"switch_slider__xtrhQ","round":"switch_round__1657l"};